// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"n_bg ml-3","matrix-table--pad4":"n_bh ml-5","matrix-table__title":"n_bj","matrix-table__true":"n_bk","matrix-table__false":"n_bl"};